import styles from './index.module.less';
import dayjs from 'dayjs';
import dynamic from 'next/dynamic';
import CompetionHead from '../competion-head';
import VVMainTitle from './v-v-MainTitle';

// 关键首屏组件 - 使用骨架屏占位
const DataComparison = dynamic(() => import('./data-comparison'), {
  ssr: false,
  loading: () => (
    <div style={{ marginTop: '50px', minHeight: '600px', backgroundColor: '#f5f5f5', borderRadius: '6px' }}></div>
  ),
});
const GoogleTrending = dynamic(() => import('./google-trending'), {
  ssr: false,
  loading: () => (
    <div style={{ marginTop: '60px', minHeight: '500px', backgroundColor: '#f5f5f5', borderRadius: '6px' }}></div>
  ),
});

// 非首屏组件 - 保持客户端渲染
const RandomPlatform = dynamic(() => import('./random-platform'), {
  ssr: false,
});
const FooterStart = dynamic(() => import('../[platform]-alternatives/FooterStart'), {
  ssr: false,
});
const SearchNow = dynamic(() => import('./SearchNow'), {
  ssr: false,
});
const FloatHeadTop = dynamic(() => import('@/components/FloatHeadTop'), {
  ssr: false,
});
import useScoll from '@/context/UseScrollHeight';
import { useConfigProvider } from '@/context/ConfigProvider';
import { useTranslation } from 'next-i18next';
import classNames from 'classnames';
import React from 'react';

const Index: React.FC<{
  platList1: any;
  platList2: any;
  sixPlatList: any[];
  googleTrendData1: any;
  googleTrendData2: any;
}> = ({ platList1, platList2, sixPlatList, googleTrendData1, googleTrendData2 }) => {
  const scrollPosition = useScoll();
  const { isMobile } = useConfigProvider();
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <FloatHeadTop />
      <div className={styles.head}>
        <CompetionHead type={2} />
      </div>
      <div className={styles.content}>
        <div className={styles.tag_head_time}>
          <ul
            className={classNames(styles.tagList, {
              [styles.fix]: scrollPosition > 300 && isMobile,
              [styles.relactve]: scrollPosition <= 300 || !isMobile,
            })}
          >
            <li>
              <a href="#Basic Information">{t('Overview')}</a>
            </li>
            <li>
              <a href="#Data Comparison">{t('Data Comparison')}</a>
            </li>
            <li>
              <a href="#Popular Topics">{t('Popular Topics')}</a>
            </li>
            <li>
              <a href="#Comparison with Other Platforms">{t('Comparison with Other Platforms')}</a>
            </li>
          </ul>
          <div>
            {t('Last Updated:')}
            <span>{dayjs().format('YYYY-MM-DD')}</span>
          </div>
        </div>
        <VVMainTitle platList1={platList1} platList2={platList2} />
        <DataComparison platList1={platList1} platList2={platList2} />
        <div style={{ minHeight: isMobile ? '300px' : '400px' }}>
          <SearchNow></SearchNow>
        </div>
        <GoogleTrending
          platList1={platList1}
          platList2={platList2}
          googleTrendData1={googleTrendData1}
          googleTrendData2={googleTrendData2}
        />
        <div style={{ minHeight: isMobile ? '400px' : '500px' }}>
          <RandomPlatform sixPlatList={sixPlatList} platListItem={platList1} platListItem1={platList2} />
        </div>
      </div>
      <FooterStart />
    </div>
  );
};

export default Index;
